import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitiatePaymentComponent } from './initiate-payment/initiate-payment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentCollectionService } from '../service/payment-collection.service';
import { PaymentRoutingModule } from './payment.routing.module';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentFailureComponent } from './payment-failure/payment-failure.component';
import { CommonSectionsModule } from '../views/common/common-sections.module';
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule, MatSelectModule, MatTabsModule } from '@angular/material';
import { TooltipModule } from '../tooltip/tooltip.module';
import { PaymentModeSavedPaymentComponent } from './payment-mode-saved-payment/payment-mode-saved-payment.component';
import { HorizontalLoaderModule } from '../horizontal-loader/horizontal-loader.module';
import { PaymentModeDebitCardComponent } from './payment-mode-debit-card/payment-mode-debit-card.component';
import { PaymentModeComponent } from './payment-mode/payment-mode.component';
import { DebitCardDirective } from '../utils/directives/debit-card-format.directive';
import { PaymentModeNetBankingComponent } from './payment-mode-net-banking/payment-mode-net-banking.component';
import { PaymentModeUpiPaymentComponent } from './payment-mode-upi-payment/payment-mode-upi-payment.component';
import { EncryptUtil } from '../utils/encrypt.util'
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [InitiatePaymentComponent, PaymentSuccessComponent, PaymentFailureComponent, PaymentModeSavedPaymentComponent, PaymentModeDebitCardComponent, PaymentModeComponent,
    DebitCardDirective,
    PaymentModeNetBankingComponent,
    PaymentModeUpiPaymentComponent],
  exports: [InitiatePaymentComponent, PaymentSuccessComponent, PaymentFailureComponent],
  imports: [
    CommonModule,
    FormsModule,
    PaymentRoutingModule,
    CommonSectionsModule,
    MatProgressSpinnerModule,
    TooltipModule,
    MatButtonModule,
    HorizontalLoaderModule,
    MatTabsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    SharedModule
  ],
  providers: [PaymentCollectionService, EncryptUtil]
})
export class PaymentModule { }
